import type { ParsedTransactionResponse } from '@/lib/api';

export type ReconciliationCase = 'new' | 'auto-link' | 'ambiguous' | 'duplicate';

export function classifyRow(row: ParsedTransactionResponse): ReconciliationCase {
  if (row.already_registered) return 'duplicate';
  const matchCount = row.matching_transactions?.length ?? 0;
  if (matchCount === 1) return 'auto-link';
  if (matchCount >= 2) return 'ambiguous';
  return 'new';
}

export function rowKey(row: ParsedTransactionResponse, index: number): string {
  return row.fitid || row.id || `row-${index}`;
}
